import { Container, Grid, Link, Typography } from "@mui/material";
import React from "react";
import {
  BtnDiv,
  ContainerWraper,
  ContentGrid,
  EmptyGrid,
  FooterDiv,
  GradiantDiv,
  Image,
  ImageGrid,
  Paragraph,
  ParentGrid,
  RoadMapDiv,
  RoadMapImage,
  RoadMapImageDiv,
  SectionWraper,
  SocialDiv,
} from "./style";
import image from "../../../assets/ethicon.png"
import LockerMenu from "../../Components/Menu";
import CustomButton from "../../Components/CustomBtn";
import { Div, GRID } from "../P2-Tokenomics/style";
const RoadMap = () => {
  return (
    <SectionWraper maxWidth="xxl">
      <GradiantDiv />
      <ContainerWraper>
        <LockerMenu />
        <ParentGrid container>
          <EmptyGrid
            item
            xs={12}
            sx={{ height: "80px", width: "100%" }}
          ></EmptyGrid>
          <ContentGrid item xs={12} sm={6}>
            <Image src="./Image/roadmapHeading.png" alt="" />
            <Paragraph>The development and launch of Baby Shibarium.</Paragraph>
            <GRID>
              <RoadMapDiv>
                <RoadMapImageDiv>
                  <RoadMapImage mw="20px" src={image} alt="" />
                </RoadMapImageDiv>
                <Typography
                  color="#fff"
                  sx={{
                    fontFamily: "PoppinsSB",
                    fontSize: "18px",
                    textAlign: "center",
                  }}
                >
                  Ethereum
                </Typography>
                <Paragraph ta="center">
                  Token launch <br /> Website launch
                  <br /> Marketing <br />
                  Medium article
                  <br /> Whitepaper
                  <br />
                  Partnerships
                  <br /> BabyShibarium Swap Preview
                </Paragraph>
              </RoadMapDiv>
              <RoadMapDiv>
                <RoadMapImageDiv>
                  <RoadMapImage src="./Image/roadmapIcon.png" alt="" />
                </RoadMapImageDiv>
                <Typography
                  color="#fff"
                  sx={{
                    fontFamily: "PoppinsSB",
                    fontSize: "18px",
                    textAlign: "center",
                  }}
                >
                  Shibarium
                </Typography>
                <Paragraph ta="center">
                  Token bridge contract launch <br />
                  Marketing
                  <br /> Partnerships
                </Paragraph>
              </RoadMapDiv>
            </GRID>
          </ContentGrid>
        </ParentGrid>
        <Grid container>
          <Grid item xs={12}>
            <FooterDiv>
              <Paragraph>
                Copyright ©2023 shibarium. baby All rights reserved.
              </Paragraph>
              <SocialDiv>
                Follow us on:
                <Link sx={{ zIndex: 1, cursor: "pointer" }}>
                  <img
                    src="./Image/twiter.png"
                    alt="Twiter"
                    style={{ margin: "0 5px" }}
                  />
                </Link>
                <Link sx={{ zIndex: 1, cursor: "pointer" }}>
                  <img
                    src="./Image/telegram.png"
                    alt="telegram"
                    style={{ margin: "0 5px" }}
                  />
                </Link>
                <Link sx={{ zIndex: 1, cursor: "pointer" }}>
                  <img
                    src="./Image/mediam.png"
                    alt="mediam"
                    style={{ margin: "0 5px" }}
                  />
                </Link>
              </SocialDiv>
            </FooterDiv>
          </Grid>
        </Grid>
      </ContainerWraper>
    </SectionWraper>
  );
};

export default RoadMap;
